module.exports = __webpack_public_path__ + "img/121.found_similar.85c2c2e0.svg";